import { atom } from "jotai"
import { atomWithStorage } from "jotai/utils"

export type CollectionGridSize = "small" | "large"

export const collectionGridSizeAtom = atomWithStorage<CollectionGridSize>("collection-grid-size", "large")

export const collectionCardImageHeightAtom = atom<number>(0)
